module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/hospital02-8374f919d35f8d0a5940b882960bd357.png";